<template>
  <div class="footer">
    <div class="qrcode_wrap">
      <img src="../assets/qrcode.jpg"/>
    </div>

    <div class="msg">
      <p> Copyright @ 2022 SHIYU All Rights Reserved. 津ICP备2022005402号-2</p>
      <a href="https://beian.miit.gov.cn" class="beianUrl">津ICP备2022005402号-2</a>
    </div>
  </div>
</template>

<script>

export default {

  setup() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 160px;
  background: #333333;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  //margin-top: 30px;

  .msg {
    color: #fff;
    margin-left: 20px;
    text-align: center;
  }
}
.beianUrl{
  color: #fff;
}
.beianUrl:hover{
  color: #3ab732;
}
</style>>
